/** 资产引用（asset://<id>@<ver>）的纯文本处理：查找、从文本里去掉（引用另行预览成卡片） */

const REF_RE = /asset:\/\/ast_[0-9A-Z]+(?:@\d+)?/g;

/** 文本里出现的资产引用（去重、保持顺序） */
export function assetRefsIn(text: string): string[] {
  return [...new Set(text.match(REF_RE) ?? [])];
}

/** 去掉文本里的资产引用并整理空白（通知、问题正文里不显示一长串 id） */
export function stripAssetRefs(text: string): string {
  return text
    .replace(REF_RE, "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}

/** 去掉"单独成行"的资产引用（能力包约定的写法：这些行在下方预览成卡片），行内引用保持原样 */
export function stripRefLines(text: string): string {
  return text
    .split("\n")
    .filter((l) => !/^\s*[-*]?\s*asset:\/\/ast_[0-9A-Z]+(?:@\d+)?\s*$/.test(l))
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
